  document.addEventListener("DOMContentLoaded", function() {
  // First section to start wrapping
  const startSection = document.querySelector(".loved__products.section");
  // Last section to end wrapping
  const endSection = document.querySelector(".insta__feed.section");

  if (startSection && endSection) {
    // Create wrapper div
    const wrapper = document.createElement("div");
    wrapper.classList.add("nature__bg");   // your background wrapper class
    wrapper.id = "js-added-wrapper";       // optional ID for reference

    // Insert wrapper before startSection
    startSection.parentNode.insertBefore(wrapper, startSection);

    // Move all siblings from startSection up to and including endSection into wrapper
    let current = startSection;
    while (current) {
      const next = current.nextSibling;
      wrapper.appendChild(current);
      if (current === endSection) break;
      current = next;
    }
  }
});
